import { render, staticRenderFns } from "./DocumentRow.vue?vue&type=template&id=3f41094f&scoped=true"
import script from "./DocumentRow.vue?vue&type=script&lang=ts"
export * from "./DocumentRow.vue?vue&type=script&lang=ts"
import style0 from "./DocumentRow.vue?vue&type=style&index=0&id=3f41094f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f41094f",
  null
  
)

export default component.exports